class collectionFilters extends HTMLElement {
  constructor() {
    super();

    this.grid = document.querySelector('#product-grid');
    this.form = document.querySelector('.filters-form');
    this.filters = document.querySelector('#filter-dropdowns');
    this.pageOverlayElement = document.querySelector('.page-overlay');

    this.drawer = this.querySelector('.filters-slideout');
    this.filterButtons = document.querySelectorAll('.filter-button');

    this.sortForm = this.querySelector('.sort-form');
    this.sortBy = this.dataset.currentSort;
    this.activeTagsContainer = document.querySelector('#active-filters');

    this.openFilterButtons = document.querySelectorAll('.js-open-filters');
    this.closeFilterButtons = document.querySelectorAll('.js-close-filters');

    this.setListeners();
  }

  setListeners() {

    // Handle Form Change
    this.form.addEventListener('change', event => {
      this.handleFilterClick(event.target);
    });

    // Handle Sort form 
    this.sortForm.addEventListener('change', event => {
      event.preventDefault();
      
      this.handleSortClick(event.target);
    });

    // Clear Category Filters
    this.addEventListener('click', event => {
      const button = event.target.closest('.js-clear-category-filters');
      if (button) {
        event.preventDefault();
        this.clearCategoryFilters();
      }
    });

    // Handle Remove Filter
    this.activeTagsContainer.addEventListener('click', event => {
      const button = event.target.tagName == 'button' ? event.target : event.target.closest('button.remove-filter')
      if (button) {
        event.preventDefault();
        const filter = button.dataset.filter;
        const initial = button.dataset.url;
        const newUrl = window.location.protocol + '//' + window.location.host + initial;
  
        if (filter) this.removeSelectedFilter(filter);
        this.reloadSections(newUrl);
      }
    });

    // Clear All Filters
    this.addEventListener('click', event => {
      const button = event.target.closest('.js-clear-all-filters');
      if (button) {
        event.preventDefault();
        this.clearAllFilters();
      }
    });

    // Open
    // this.openFilterButtons.forEach(filter => {
    //   filter.addEventListener('click', event => {
    //     this.open();
    //   });
    // });

    // Close
    // this.closeFilterButtons.forEach(filter => {
    //   filter.addEventListener('click', event => {
    //     this.close();
    //   });
    // });
  }

  open() {
    event.preventDefault();

    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);
  }

  close() {
    event.preventDefault();
  
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.setAttribute('aria-expanded', false);
  }

  handleFilterClick() {
    this.reloadSections();
  }

  removeSelectedFilter(filter) {
    if(filter.includes('filter.v.price')){
      document.querySelector(`.price-range__input-field[name="filter.v.price.gte"]`).value = ""
      document.querySelector(`.price-range__input-field[name="filter.v.price.lte"]`).value = ""
    } else {
      document.querySelector(`.collection-filters__filter-button[data-filter="${filter}"]:checked`).checked = false;
    }
  }

  handleSortClick(target) {
    const sort = target.value;
    this.sortBy = sort;
    
    this.reloadSections();
  }

  clearCategoryFilters(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    event.target.parentElement.querySelectorAll('.filter-button').forEach(item => {
      item.removeAttribute('checked');
    });

    this.reloadSections();
  }

  clearAllFilters() {
    event.preventDefault();
    event.stopImmediatePropagation();

    document.querySelectorAll('.filter-button').forEach(item => {
      item.removeAttribute('checked');
    });

    this.reloadSections();
    this.close();
  }

  reloadSections(newUrl) {
    let url = '';
    
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    let sortByText = searchParams ? '&sort_by=' : 'sort_by=';

    url = location.pathname + '?' + searchParams + sortByText + this.sortBy;

    if (history.replaceState) {
      window.history.pushState({ path: url }, '', url);
    }

    // Fetch and replace sections
    this.enableLoading();
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        const htmlContent = new DOMParser().parseFromString(html, 'text/html');

        // Replace sections
        this.getSectionsToRender().forEach((section => {
          document.getElementById(section.id).innerHTML = htmlContent.getElementById(section.id).innerHTML;
        }));

        // // Replace dropdown button text
        // const dropdownButtonContents = this.querySelectorAll('.filter-dropdown');
        // dropdownButtonContents.forEach(content => {
        //   const newContent = htmlContent.getElementById(content.id).innerHTML;
        //   content.innerHTML = newContent;
        // });

        // // Replace dropdown filters
        // const dropdownContents = this.querySelectorAll('.filter-dropdown__content-container');
        // dropdownContents.forEach(content => {
        //   const newContent = htmlContent.getElementById(content.id).innerHTML;
        //   content.innerHTML = newContent;
        // });
      
        this.disableLoading();
      })
      .catch(() => {
        this.disableLoading();
      })
      .finally(() => {

      });
  }

  getSectionsToRender() {
    return [
      { id: 'product-grid' },
      { id: 'active-filters'}
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    // this.grid.classList.add('loading');
  }

  disableLoading() {
    // this.grid.classList.remove('loading');
  }
}

customElements.define('collection-filters', collectionFilters);